export default __webpack_public_path__ + "static/media/about.4aa59f7b.svg";